import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

import { useCitationDelete } from '../model/CitationQuery';

interface CitationDeleteButtonProps {
  citationId: Id;
  publicationId: Id;
}

export function CitationDeleteButton({ citationId, publicationId }: CitationDeleteButtonProps) {
  const mutation = useCitationDelete(publicationId, citationId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      miw="100px"
      size="xs"
      {...deleteProps}
    />
  );
}
